import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { throwIfErrorPresent } from 'features/Onboarding/utils';

import { isMissingProofOfAddressQuery } from './graphql';
import {
  IsMissingProofOfAddressHook,
  IsMissingProofOfAddressQueryData,
  IsMissingProofOfAddressQueryVariables,
} from './types';

const useIsMissingProofOfAddress: IsMissingProofOfAddressHook = () => {
  const { companyProfileId } = useCompanyContext();
  const { data, error, loading } = useQuery<
    IsMissingProofOfAddressQueryData,
    IsMissingProofOfAddressQueryVariables
  >(isMissingProofOfAddressQuery, {
    skip: !companyProfileId,
    variables: {
      companyProfileId,
    },
  });
  throwIfErrorPresent(error);

  const proofOfAddressDocuments =
    data?.viewer.companyUser.proofOfAddressDocuments || [];
  const isMissingProofOfAddress =
    data === undefined
      ? undefined
      : proofOfAddressDocuments.some(({ status }) => status === 'MISSING');
  return {
    isMissingProofOfAddress,
    loading,
  };
};

export default useIsMissingProofOfAddress;
